import { type ReactNode } from 'react';

import { FieldClaimFrame } from './FieldClaimFrame';
import { useTemplateFieldPresence } from './useTemplateFieldPresence';

/**
 * Read-only presence view of a claimable field: members who can't edit still
 * see who is editing what (border + name), with nothing to block. With
 * `onlyWhenClaimed`, the field renders only while a claim exists — for
 * content a collaborator is authoring but hasn't committed yet (a new
 * description or reference note), where there is otherwise nothing to show.
 */
export function SpectatorField({
  fieldKey,
  onlyWhenClaimed = false,
  className,
  children,
}: {
  fieldKey: string;
  onlyWhenClaimed?: boolean;
  className?: string;
  children?: ReactNode;
}) {
  const presence = useTemplateFieldPresence();
  const claims = presence.claimsFor(fieldKey);
  if (onlyWhenClaimed && claims.length === 0) return null;
  return (
    <FieldClaimFrame field={{ claims }} className={className}>
      {children}
    </FieldClaimFrame>
  );
}
